import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {TableColumn} from '../../../../../../../../../src/components/common/table/tableColumn';
import {TableRowRenderOptions} from '../../../../../../../../../src/components/common/table/tableRow';
import {
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../../../../../../../src/helpers/reselectHelpers';
import {AppState} from '../../../../../../../../../src/store/appState';
import {makeGetCardGroups} from '../../../../../../../../../src/store/data/cardGroups/cardGroupsSelectors';
import {makeGetCard} from '../../../../../../../../../src/store/data/cards/cardsSelectors';
import {getAccounts} from '../../../../../../../../../src/store/data/dataSelectors';
import {getSizes} from '../../../../../../../../../src/store/data/localPreferences/localPreferencesSelectors';
import {popoutAccountDetailsAction} from '../../../../../../../../../src/store/panels/accounts/accountDetailsPanelActions';
import {popoutContactDetailsAction} from '../../../../../../../../../src/store/panels/contacts/contactDetailsPanelActions';
import {ContactsManagerPanelId} from '../../../../../../../../../src/store/panels/panelStateBase';
import {Handler, HandlerOf} from '../../../../../../../../shared/helpers/src/react/reactHelpers';
import {ContactsTableColumnsEnum} from '../../common/contacts/contactsTableConfig';
import {ContactsTableRow} from './contactsTableRow';

/*
 * Props.
 */

interface ContactsTableRowContainerPublicProps {
  cardId: number;
  panelId: ContactsManagerPanelId;
  isSelected: boolean;
  tableColumns: TableColumn<ContactsTableColumnsEnum>[];
  options: TableRowRenderOptions;
  isPreviousSiblingSelected: boolean;
  isNextSiblingSelected: boolean;
  isInMultiSelectMode: boolean;
  onSelect: Handler;
  onMultiSelect: Handler;
  onCheckBoxToggle: HandlerOf<boolean>;
}

/*
 * Selectors.
 */

function getCardId(_state: AppState, props: ContactsTableRowContainerPublicProps) {
  return props.cardId;
}

function makeGetAccount(getCard: ReturnType<typeof makeGetCard>) {
  return createSelector([getCard, getAccounts], (card, accounts) => {
    if (!card || !card.accountId) {
      return undefined;
    }
    return accounts[card.accountId];
  });
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => {
  const getCard = makeGetCard(getCardId);
  return {
    card: getCard,
    cardGroups: makeGetCardGroups(getCard),
    account: makeGetAccount(getCard),
    sizes: getSizes,
  };
});

const mapDispatchToProps = makeMapDispatchToProps<ContactsTableRowContainerPublicProps>()((props) => ({
  openContactDetailsPopUp: (contactUid: string) =>
    popoutContactDetailsAction({
      parentPanelId: props.panelId,
      selectedContactUid: contactUid,
      shouldFetchContact: true,
      shouldHideHeaderTabs: true,
    }),
  onOpenAccountDetailsPopUp: (accountId: number, popupWidth: number | undefined) =>
    popoutAccountDetailsAction(props.panelId, accountId, popupWidth),
}));

export const ContactsTableRowContainer = connect(mapStateToProps, mapDispatchToProps)(ContactsTableRow);
